import { CustomsNonDelivery } from '../../../../../../../../enums/customs-non-delivery';
import { ACTION_TYPE_SET_INTERNATIONAL_NON_DELIVERY } from '../../../../../constants/action-types';
import { propertyForUpdateByActionType } from '../property-for-update-by-action-type';

const propertyForUpdate = propertyForUpdateByActionType(ACTION_TYPE_SET_INTERNATIONAL_NON_DELIVERY);

export default Object.values(CustomsNonDelivery).map((option) => ({
  [propertyForUpdate]: option.name,
  messageDescriptor: option.translation,
}));
